import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import { D1EventsEdit } from "./edit";
import { D1EventsNew } from "./new";
import { D1EventsTable } from "./table";

export default function D1Events() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Events");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<D1EventsEdit />} />
      <Route index element={<D1EventsTable />} />
      <Route path="/new" element={<D1EventsNew />} />
    </Routes>
  );
}
